import PropTypes from "prop-types";
import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card, Button, TextInput } from "@opendate-app/setlist";

import { toastError } from "../../../shared/toastHelper";
import "./TrackableLinkQrCodeApp.css";

const TrackableLinkQrCodeApp = ({ eventTitle, linkName, qrUrl, downloadUrls }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const notifyFailure = () =>
      toastError("Couldn't copy the link. Select the URL to copy it manually.");
    const copy = navigator.clipboard?.writeText(qrUrl);
    if (!copy) {
      notifyFailure();
      return;
    }
    copy.then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(notifyFailure);
  };

  return (
    <div className="tl-qr-page">
      <Card>
        <div className="tl-qr-card">
          <h2 className="tl-qr-title">{eventTitle}</h2>
          <p className="tl-qr-subtitle">
            {linkName ? `Tracking QR · ${linkName}` : "Tracking QR"}
          </p>

          <div className="tl-qr-code" aria-label="Trackable link QR code">
            <QRCodeSVG value={qrUrl} size={320} level="M" style={{ display: "block" }} />
          </div>

          <div className="tl-qr-url">
            <TextInput
              label="Tracking URL"
              value={qrUrl}
              readOnly
              onFocus={(e) => e.target.select()}
            />
            <Button variant="secondary" onClick={handleCopy}>
              {copied ? "Copied!" : "Copy"}
            </Button>
          </div>

          <p className="tl-qr-download-label">Download</p>
          <div className="tl-qr-downloads">
            <a href={downloadUrls.png} download className="btn-setlist-primary">PNG</a>
            <a href={downloadUrls.svg} download className="btn-setlist-primary">SVG</a>
            <a href={downloadUrls.pdf} download className="btn-setlist-primary">PDF</a>
          </div>
        </div>
      </Card>

      <p className="tl-qr-footnote">
        This QR encodes your trackable link, so scans are attributed like any other visit from it.
      </p>
    </div>
  );
};

TrackableLinkQrCodeApp.propTypes = {
  eventTitle: PropTypes.string.isRequired,
  linkName: PropTypes.string,
  qrUrl: PropTypes.string.isRequired,
  downloadUrls: PropTypes.shape({
    png: PropTypes.string.isRequired,
    svg: PropTypes.string.isRequired,
    pdf: PropTypes.string.isRequired,
  }).isRequired,
};

export default TrackableLinkQrCodeApp;
